import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ContentTabModel } from 'src/app/models/content-tab';

@Component({
    selector: 'app-content-tab',
    templateUrl: './content-tab.component.html',
    styleUrls: ['./content-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentTabComponent implements OnInit {

  @Input() tab: ContentTabModel;

  @Output() onTabClick: EventEmitter<ContentTabModel> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onTabClicked(): void{
    this.onTabClick.emit(this.tab);
  }

}
